import React from "react";

// Custom.
import Layout from "containers/Layout/Layout";
import Dashboard from "containers/Dashboard";
// import { VoLogo } from "@vocollege/components";

const DashboardPage: React.FC = (props) => {
  return (
    <Layout>
      <Dashboard className="vo-global__top-bottom-space" />
    </Layout>
  );
};

export default DashboardPage;
